import { render, staticRenderFns } from "./myResources.vue?vue&type=template&id=1ba01600&scoped=true"
import script from "./myResources.vue?vue&type=script&lang=js"
export * from "./myResources.vue?vue&type=script&lang=js"
import style0 from "./myResources.vue?vue&type=style&index=0&id=1ba01600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba01600",
  null
  
)

export default component.exports